let btnActions = function(i, idx) {
	this.Actionsdropd[idx] = !this.statusdropd[idx];
	if (this.Actionsdropd[idx]) {
		this.ActionsSelected = idx;
		this.activateActions(i);
	}
};
export default btnActions;
